import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import UserPortalNavBar from '../UserPortalNavBar'

class LockerNav extends Component {
  state = {
    tabs: {
      primary: [],
      secondary: [],
    }
  }

  componentDidMount() {
    this.setPrimaryNavItems(this.props)
    this.setSecondaryNavItems(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.setPrimaryNavItems(nextProps)
    this.setSecondaryNavItems(nextProps)
  }

  setPrimaryNavItems(props) {
    const { playerProfile } = props;

    let primaryTabs = playerProfile.participations.map((sport) => {
      return {
        title: sport.sport_name,
        slug: sport.sport_slug,
        path: `/locker/${sport.sport_slug}/profile`
      }
    })

    this.setState(state => ({
      ...state,
      tabs: {
        ...state.tabs,
        primary: primaryTabs
      }
    }))
  }

  setSecondaryNavItems(props) {
    const { currentSport } = props

    let secondaryTabs = [
      {
        title: 'Profile',
        slug: 'profile',
        path: `/locker/${currentSport}/profile`
      },
      {
        title: 'Photos & Videos',
        slug: 'photos-videos',
        path: `/locker/${currentSport}/photos-videos`
      },
      {
        title: 'Awards',
        slug: 'awards',
        path: `/locker/${currentSport}/awards`
      },
      {
        title: 'Stats',
        slug: 'stats',
        path: `/locker/${currentSport}/stats`
      },
      {
        title: 'Camps',
        slug: 'camps',
        path: `/locker/${currentSport}/camps`
      },
      {
        title: 'Contact',
        slug: 'contact',
        path: `/locker/${currentSport}/contact`
      },
    ]

    this.setState(state => ({
      ...state,
      tabs: {
        ...state.tabs,
        secondary: secondaryTabs
      }
    }))
  }

  render() {
    const { currentSport, currentSection } = this.props;
    const { tabs } = this.state;

    return (
      <nav className="locker-nav">
        { tabs.primary.length > 1 &&
          <UserPortalNavBar
            className="primary"
            currentTab={currentSport}
            tabs={tabs.primary}
          />
        }
        <UserPortalNavBar
          currentTab={currentSection}
          tabs={tabs.secondary}
        />
      </nav>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    accountDetails: state.accountDetails,
  }
}

export default connect(
  mapStateToProps,
  null
)(LockerNav)



// WEBPACK FOOTER //
// ./src/components/UserPortal/Locker/LockerNav.js